export default "__VITE_ASSET__BNHxeHqs__"